"use client"

import { createContext, useContext, useState } from 'react'

const SetActivePhotoContext = createContext(() => {})
const GetActivePhotoContext = createContext('')
const ActivePhotoContextProvider = ({ children, offer,
    defaultActivePhoto = 0 }) => {

    const [activePhoto, setActivePhoto] = useState(defaultActivePhoto)
    return (
        <SetActivePhotoContext.Provider value={setActivePhoto}>
            <GetActivePhotoContext.Provider value={activePhoto}>
                {children}
            </GetActivePhotoContext.Provider>
        </SetActivePhotoContext.Provider>
    )
}

export const useSetActivePhoto = () => {
    return useContext(SetActivePhotoContext)
}

export const useActivePhoto = () => {
    return useContext(GetActivePhotoContext)
}

export default ActivePhotoContextProvider